import React, { Component } from 'react';
import MyInput from 'components/controls/MyInput';
import InputCheck from 'components/controls/InputCheck';
import ButtonComponent from 'components/controls/Button';
import _StudentService from '../../modules/StudentService.js';
import _AdminService from '../../modules/AdminService.js';
import { DatePicker, Icon } from 'antd';
import _notification from 'modules/notification';
import moment from 'moment';
import QualificationRow from './QualificationRow_new.jsx';
import _utils from '../../modules/Utils.js';
import QualificationTableHeader from 'components/controls/QualificationTableHeader_new';
import NavigationTab from './NavigationTab_new_one.jsx';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import add_new from "assets/img/add_new.png";
import remove from "assets/img/remove.png";
// Stage 3.5 (Enterprise Candidate Registration Wizard Modernization): the Stage 3.2 shared Card
// replaces this page's 4 `.candidateform-cover` sections.
import Card from 'components/enterprise/Card';
import Text, { resolveText } from 'components/Text/Text';
import { getCurrentLocale, getCurrentDisplayMode } from 'modules/LanguageContext';
const _ = require('lodash');

// Stage 3.9 (Task 2/5): the img title/alt attributes below are plain strings (not JSX-friendly
// props), so they use the plain resolveText() helper — same idiom as NewLogin.jsx/ResetPassword.jsx.
function tr(key) {
    return resolveText(key, getCurrentLocale(), getCurrentDisplayMode());
}

class CandidateQualificationInfo_new extends Component {
    constructor(props) {
        super(props);
        this.textInput = React.createRef()
        this.state = {
            allQualification: [],
            parentQualification: [],
            candidateQualification: [],
            otherInformation: [],
            allUniversities: [],
            loading: false,
            student_ID: localStorage["SID"],
            config: {},
            postData: {},
            mappingIds: [],
            candidatePersonalInfo: {},
            percentageData: [],
            gradeData: [],
            selectedPostID: 0,
        };
    }

    componentDidMount() {
        if (this && this.props && this.props.data && this.state.candidatePersonalInfo &&
            this.props.data.Applied_PostId !== this.state.candidatePersonalInfo.Applied_PostId) {
            this.setState({
                candidatePersonalInfo: this.props.data
            })
        }

        this.getStudentQualificationData();
        this.getConfigurations();
        this.getCandidatePostData();
        this.getPostConfigurationData();
    }

    getConfigurations = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let temp = await _AdminService.GetPortalConfiguration();
                    this.setState({
                        ...this.state,
                        config: temp.data,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    getCandidatePostData = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {

                    let temp = await _StudentService.GetCandidatePostData();

                    this.setState({
                        ...this.state,
                        postData: temp.data,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    //API operations
    getPostConfigurationData = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let portalConfiguration = await _AdminService.GetPostConfigurationData(this.state.candidatePersonalInfo.Applied_PostId, '');
                    let tempTypeLst = _utils.groupJSONArrayOfObjectsByKey(portalConfiguration.data.Obj.listPostConfiguration, 'Type');

                    let tempPercentage = portalConfiguration.data.Obj.listPostConfiguration.filter((item) => item.Type == 'Qualification Percentage');
                    let tempGrade = portalConfiguration.data.Obj.listPostConfiguration.filter((item) => item.Type == 'Qualification Grade');


                    this.setState({
                        ...this.state,
                        percentageData: tempPercentage,
                        gradeData: tempGrade
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    getStudentQualificationData = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let allQualificationListTemp = await _StudentService.getAllQualification();
                    let candidateQualificationList = await _StudentService.getStudentQualificationData();
                    let allUniversities = await _StudentService.getAllUniversity();

                    let allQualificationList = allQualificationListTemp.data;
                    // if ((this.state.candidatePersonalInfo && this.state.candidatePersonalInfo.Applied_PostId === JUNIOR_MANAGEMENT_ID) ||
                    //     (this.state.candidatePersonalInfo && this.state.candidatePersonalInfo.Applied_PostId === JUNIOR_CLERK_ID)) {

                    //     allQualificationList = allQualificationListTemp.data.filter((item) => item.Qualification_Name !== "Other " && item.Qualification_Name !== "Other")
                    // }

                    let otherInfo;
                    if (!candidateQualificationList.data.otherInformation || candidateQualificationList.data.otherInformation.length == 0) {
                        otherInfo = {
                            Is_Marathi_Typing_30: false,
                            Is_English_Typing_40: false,
                            Is_100_WPM: false,
                            Is_120_WPM: false,
                            Organisation: null,
                            Designation: null,
                            From_Date: null,
                            To_Date: null
                        };
                    }

                    // let tempParentQual = Object.groupBy(candidateQualificationList.data.listStudentQualificationDetails, ({ Qualification_Id }) => Qualification_Id);
                    let tempParentQual = _.groupBy(candidateQualificationList.data.listStudentQualificationDetails, ({ Qualification_Id }) => Qualification_Id);

                    let _tempQualification = [];
                    let _tempData = [];
                    let tempMappingIds = [];
                    for (const property in tempParentQual) {
                        for (let i = 1; i < tempParentQual[property].length; i++) {

                            let tempData = { ...allQualificationList.find((item) => item.ParentId === null && item.Id == property) };
                            let tempQualification = [...allQualificationList.filter((item) => item.ParentId == tempData.Id)];

                            tempData._parentID = tempData.Id;
                            tempData.Id = Math.floor(Math.random() * (9999999 - 10000 + 1) + 10000);

                            tempMappingIds.push(`${tempData._parentID}_${tempData.Id}`);

                            tempParentQual[property][i].Qualification_Id = tempData.Id;

                            tempQualification && tempQualification.map(item => {
                                _tempQualification.push({ ...item, ParentId: tempData.Id });
                            })

                            _tempData.push(tempData);
                        }
                    }

                    let tempParent = allQualificationList.filter((item) => item.ParentId === null);
                    tempParent && tempParent.map(item => item._parentID = item.Id);

                    this.setState({
                        ...this.state,
                        allQualification: [...allQualificationList, ..._tempQualification, ..._tempData],
                        parentQualification: [...tempParent, ..._tempData],
                        candidateQualification: candidateQualificationList.data.listStudentQualificationDetails,
                        otherInformation: !otherInfo ? candidateQualificationList.data.otherInformation : [otherInfo],
                        allUniversities: allUniversities.data,
                        loading: false,
                        mappingIds: [...tempMappingIds]
                    })

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    onCandidateQualification = (data) => {
        try {
            const newState = this.state.candidateQualification;
            if (!data.hasOwnProperty('Id') && data.hasOwnProperty('newRowID')) {
                let index = newState.findIndex((item) => item.newRowID == data.newRowID);

                let tempdata = newState;
                if (index != -1) {
                    tempdata[index] = data;
                }
                else {
                    tempdata.push(data);
                }
                this.setState({
                    ...this.state,
                    candidateQualification: tempdata,
                });
            }
            if (data.hasOwnProperty('Id')) {
                let index = newState.findIndex((item) => item.Id == data.Id);

                let tempdata = newState;
                if (index != -1) {
                    tempdata[index] = data;
                }
                else {
                    tempdata.push(data);
                }

                this.setState({
                    ...this.state,
                    candidateQualification: tempdata,
                });
            }
        } catch (e) { }
    }

    isValid = (result) => {
        
        var valid = true;

        if (!this.isMandatoryQualificationFilled(result)) {
            return false;
        }

        if (!result.length) {
            valid = false;
            _notification.showMessage('error', 'Please provide at least one Education details.');
        }

        let newThis = this;
        result.map(item => {
            let found = this.state.allQualification.filter((x) => x.Id == item.Qualification_Id);

            if (item.Other_Information && (!item.Passed_Year || !item.Percentage_Grade || !item.Class)) {
                _notification.showMessage('error', 'Please provide valid details in education: ' + (found && found[0] ? found[0].Qualification_Name : ""));
                valid = false;
            }

            let hasSpecialization = this.state.allQualification.filter((row) => row.ParentId == item.Qualification_Id);
            if (item.University_Id && (hasSpecialization.length && !item.Specilisation_Id)) {
                _notification.showMessage('error', 'Please provide valid details in education: ' + (found && found[0] ? found[0].Qualification_Name : ""));
                valid = false;
            }

            if(item.Specilisation === "Other" && item.other_specilisation === ""){
                _notification.showMessage('error', 'Please provide valid details in education: ' + (found && found[0] ? found[0].Qualification_Name : ""));
                valid = false;   
            }

            if (item.University_Id && (!item.Passed_Year || !item.Percentage_Grade || !item.Class)) {
                _notification.showMessage('error', 'Please provide valid details in education: ' + (found && found[0] ? found[0].Qualification_Name : ""));
                valid = false;
            }

            if (!item.Other_Information && !item.University_Id) {
                _notification.showMessage('error', 'Please provide valid details in education: ' + (found && found[0] ? found[0].Qualification_Name : ""));
                valid = false;
            }

            let newString = item.Passed_Year.toString();

            if ((item.Passed_Year != "") && item.Passed_Year < 1900 && newString.length == 4) {
                _notification.showMessage('error', 'Please provide valid Passing Year details in education: ' + (found && found[0] ? found[0].Qualification_Name : ""));
                valid = false;
            }

            let newStr = item.Passed_Year.toString();

            if ((item.Passed_Year != "") && newStr.length != 4) {
                _notification.showMessage('error', 'Please provide valid Passing Year details in education: ' + (found && found[0] ? found[0].Qualification_Name : ""));
                valid = false;
            }

            // if(newThis && newThis.state && newThis.state.candidatePersonalInfo && newThis.state.candidatePersonalInfo.Applied_PostId &&
            //     (newThis.state.candidatePersonalInfo.Applied_PostId === JUNIOR_MANAGEMENT_ID || newThis.state.candidatePersonalInfo.Applied_PostId === MANAGER_ID ||
            //     if (item.Qualification_Id && item.Qualification_Id === Qualification_DEGREE_ID) {
            //         
            //         let Percentage_Grade = item.Percentage_Grade || '';

            //         if (Percentage_Grade.includes("%")) {
            //             Percentage_Grade = Percentage_Grade.replace("%", "").trim();
            //         }

            //         const isNumeric = /^\d+(\.\d+)?$/.test(Percentage_Grade);

            //         if (isNumeric) {
            //             if (parseFloat(Percentage_Grade) < 60) {
            //                 _notification.showMessage('error', 'Percentage should be greater than or equal to 60%.');
            //                 valid = false;
            //             }
            //         } else {
            //             const isGrade = /^(A\+?|B\+?)$/i.test(Percentage_Grade);

            //             if (!isGrade) {
            //                 _notification.showMessage('error', 'Invalid grade. Grade should be A, A+, B, or B+.');
            //                 valid = false;
            //             }
            //         }
            //     }
            // }
            // else
            //  if(newThis.state.candidatePersonalInfo.Applied_PostId === JUNIOR_CLERK_ID){
            //     if (item.Qualification_Id && item.Qualification_Id === Qualification_DEGREE_ID) {
            //         let Percentage_Grade1 = item.Percentage_Grade || '';

            //         if (Percentage_Grade1.includes("%")) {
            //             Percentage_Grade1 = Percentage_Grade1.replace("%", "").trim();
            //         }

            //         const isNumeric = /^\d+(\.\d+)?$/.test(Percentage_Grade1);

            //         if (isNumeric) {
            //             if (parseFloat(Percentage_Grade1) < 50) {
            //                 _notification.showMessage('error', 'Please select a relevant degree with at least 50% marks or Grade B');
            //                 valid = false;
            //             }
            //         } else {
            //             const isGrade = /^(A\+?|B\+?)$/i.test(Percentage_Grade1);

            //             if (!isGrade) {
            //                 _notification.showMessage('error', 'Please select a relevant degree with at least 50% marks or Grade B');
            //                 valid = false;
            //             }
            //         }
            //     }
            // }

            // if (
            //     newThis && newThis.state && newThis.state.candidatePersonalInfo && newThis.state.candidatePersonalInfo.Applied_PostId &&
            //     (
            //         newThis.state.candidatePersonalInfo.Applied_PostId === LAW_OFFICER_BANKING_OFFICER_GR2_ID ||
            //         newThis.state.candidatePersonalInfo.Applied_PostId === ASSISTANT_LAW_OFFICER_CLERK_ID ||
            //         newThis.state.candidatePersonalInfo.Applied_PostId === CA_BANKING_OFFICER_GR1_ID ||
            //         newThis.state.candidatePersonalInfo.Applied_PostId === IT_OFFICERS_BANKING_OFFICER_GR1_ID ||
            //         newThis.state.candidatePersonalInfo.Applied_PostId === IT_OFFICERS_BANKING_OFFICER_GR2_ID ||
            //         newThis.state.candidatePersonalInfo.Applied_PostId === STENOGRAPHER_CLERK_ID ||
            //         newThis.state.candidatePersonalInfo.Applied_PostId === ACCOUNTANT_BANKING_OFFICER_GR2_ID ||
            //         newThis.state.candidatePersonalInfo.Applied_PostId === CLERK_ID

            //     )
            // ) {
            //     if (
            //         item.Qualification_Id &&
            //         [Qualification_DEGREE_ID, Qualification_PG_ID, Qualification_Diploma_ID].includes(item.Qualification_Id)
            //     ) 

            //    {
            //         let Percentage_Grade = item.Percentage_Grade || '';

            //         // Remove % symbol if present
            //         if (Percentage_Grade.includes("%")) {
            //             Percentage_Grade = Percentage_Grade.replace("%", "").trim();
            //         }

            //         // Check if Percentage_Grade is a numeric value
            //         const isNumeric = /^\d+(\.\d+)?$/.test(Percentage_Grade);

            //         if (isNumeric) {
            //             const percentageValue = parseFloat(Percentage_Grade);

            //             if (percentageValue < 50) {
            //                 _notification.showMessage('error', 'Percentage should be greater than or equal to 50%.');
            //                 valid = false;
            //             } else if (percentageValue > 100) {
            //                 _notification.showMessage('error', 'Percentage should be less than or equal to 100%.');
            //                 valid = false;
            //             }
            //         } else {
            //             // Validate grade
            //             const validGrades = ["A", "A+", "B", "B+"];
            //             const percentageUpper = Percentage_Grade.toUpperCase().trim();

            //             if (!validGrades.includes(percentageUpper)) {
            //                 _notification.showMessage('error', 'Invalid grade. Valid grades are A, A+, B, or B+.');
            //                 valid = false;
            //             }
            //         }
            //     }
            // }


            // if (
            //     newThis && newThis.state && newThis.state.candidatePersonalInfo && newThis.state.candidatePersonalInfo.Applied_PostId &&
            //     (
            //         newThis.state.candidatePersonalInfo.Applied_PostId === LAW_OFFICER_BANKING_OFFICER_GR2_ID ||
            //         newThis.state.candidatePersonalInfo.Applied_PostId === ASSISTANT_LAW_OFFICER_CLERK_ID ||
            //         newThis.state.candidatePersonalInfo.Applied_PostId === CA_BANKING_OFFICER_GR1_ID ||
            //         newThis.state.candidatePersonalInfo.Applied_PostId === IT_OFFICERS_BANKING_OFFICER_GR1_ID ||
            //         newThis.state.candidatePersonalInfo.Applied_PostId === IT_OFFICERS_BANKING_OFFICER_GR2_ID ||
            //         newThis.state.candidatePersonalInfo.Applied_PostId === STENOGRAPHER_CLERK_ID ||
            //         newThis.state.candidatePersonalInfo.Applied_PostId === ACCOUNTANT_BANKING_OFFICER_GR2_ID ||
            //         newThis.state.candidatePersonalInfo.Applied_PostId === CLERK_ID ||
            //         newThis.state.candidatePersonalInfo.Applied_PostId === TESTPOST_ID


            //     )
            // ){


            if (Array.isArray(this.state.percentageData) && this.state.percentageData.length > 0 && (typeof item.Percentage_Grade === 'number' || !isNaN(parseFloat(item.Percentage_Grade)))) {
                let percentageErrorShown = false;

                this.state.percentageData.forEach(percentageItem => {
                    if (percentageItem && percentageItem.Value > 0 && percentageItem.RefId1 == item.Qualification_Id) {
                        let Percentage = String(percentageItem.Value).replace("%", "").trim();
                        const isNumeric = /^\d+(\.\d+)?$/.test(Percentage);
                        //gradeData.RefId1 == item.Qualification.Id  
                        if (isNumeric) {
                            let percentageValue = parseFloat(Percentage);
                            let Percentage_Grade = parseFloat(item.Percentage_Grade)
                            let Qualification_Name = percentageItem.Name;

                            if (percentageValue > Percentage_Grade) {
                                if (!percentageErrorShown) {
                                    _notification.showMessage('error', `${Qualification_Name} Percentage should be greater than or equal to ${percentageValue}`);
                                    percentageErrorShown = true;
                                }
                                valid = false;
                            } else if (Percentage_Grade > 100) {
                                if (!percentageErrorShown) {
                                    _notification.showMessage('error', `${Qualification_Name} Percentage should be less than or equal to 100%.`);
                                    percentageErrorShown = true;
                                }
                                valid = false;
                            }

                        } else {
                            if (!percentageErrorShown) {
                                _notification.showMessage('error', 'Invalid percentage format.');
                                percentageErrorShown = true;
                            }
                            valid = false;
                        }
                    }
                });

            } else if (Array.isArray(this.state.gradeData) && this.state.gradeData.length > 0 && typeof item.Percentage_Grade === 'string' && isNaN(item.Percentage_Grade)) {
                let gradeErrorShown = false;
                let gradeMismatchErrorShown = false;

                for (let i = 0; i < this.state.gradeData.length; i++) {
                    const gradeItem = this.state.gradeData[i];

                    if (gradeItem && gradeItem.ValueStr && gradeItem.RefId1 == item.Qualification_Id) {
                        let gradeValue = gradeItem.ValueStr.toUpperCase().trim();

                        // Check if Percentage_Grade is a valid number (if it is, it's a numeric grade)
                        let percentageGrade = item?.Percentage_Grade?.toUpperCase().trim(); // Ensure 'item' is in scope
                        let Qualification_Name = gradeItem.Name;

                        // Otherwise, we treat it as a grade string (like "A,B,A+,B+")
                        const isValidGradeString = /^[A-Z+\s,]+$/.test(gradeValue); // Validates formats like A, B+, etc.

                        if (isValidGradeString) {
                            let allowedGrades = gradeValue
                                .split(',')
                                .map(g => g.trim())
                                .filter(g => g.length > 0); // Removes empty entries

                            if (percentageGrade && !allowedGrades.includes(percentageGrade)) {
                                if (!gradeMismatchErrorShown) {
                                    _notification.showMessage('error', `${Qualification_Name} Invalid grade: ${percentageGrade}. Please enter a valid grade.`);
                                    gradeMismatchErrorShown = true;
                                }
                                valid = false;
                            }

                        } else {
                            if (!gradeErrorShown) {
                                _notification.showMessage('error', 'Invalid grade format.');
                                gradeErrorShown = true;
                            }
                            valid = false;
                        }
                    }
                }
            }






            //For Work Experience
            if (this.state.postData.YearInExperience && this.state.postData.YearInExperience > 0) {
                let errorShown = false;

                if (!this.errorHandled) {
                    this.state.otherInformation.some(workExp => {
                        if ((workExp.Organisation == null || workExp.Organisation == "" ||
                            workExp.From_Date == null || workExp.From_Date == "" ||
                            workExp.To_Date == null || workExp.To_Date == "") ||
                            workExp.Designation == null || workExp.Designation == "") {

                            if (!errorShown) {
                                _notification.showMessage('error', 'Please provide valid Work Experience details');
                                valid = false;
                                errorShown = true;
                                this.errorHandled = true;
                            }

                            return true; // Exit the loop after showing the error message
                        }
                        return false; // Continue the loop
                    });
                }

                // Reset the errorHandled flag after the render cycle
                setTimeout(() => {
                    this.errorHandled = false;
                }, 0);
            }
        })


        function isLeapYear(year) {
            return (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
        }

        function daysInYear(year) {
            return isLeapYear(year) ? 366 : 365;
        }

        let totalExperience = 0;

        this.state.otherInformation.forEach(job => {
            const startDate = new Date(job.From_Date);
            const endDate = job.To_Date ? new Date(job.To_Date) : new Date();

            // Include the end date in the calculation by adding one day
            endDate.setDate(endDate.getDate() + 1);

            let totalYears = endDate.getFullYear() - startDate.getFullYear();
            let totalMonths = endDate.getMonth() - startDate.getMonth();
            let totalDays = endDate.getDate() - startDate.getDate();

            // Adjust for negative month or day differences
            if (totalDays < 0) {
                totalMonths -= 1;
                const prevMonthDays = new Date(endDate.getFullYear(), endDate.getMonth(), 0).getDate();
                totalDays += prevMonthDays;
            }

            if (totalMonths < 0) {
                totalYears -= 1;
                totalMonths += 12;
            }

            // Convert months and days into fractional years
            const monthFraction = totalMonths / 12;
            const dayFraction = totalDays / daysInYear(endDate.getFullYear());

            // Sum up the total experience for this job
            totalExperience += totalYears + monthFraction + dayFraction;
        });


        //Validate experience strictly (no rounding or truncation)

        // if (this.state.candidatePersonalInfo && this.state.candidatePersonalInfo.Applied_PostId == LAW_OFFICER_BANKING_OFFICER_GR2_ID) {
        //     if (totalExperience < 3) {
        //         _notification.showMessage('error', 'Minimum 3 Years of Work Experience is required');
        //         valid = false;
        //     }
        // }

        // if (this.state.candidatePersonalInfo && this.state.candidatePersonalInfo.Applied_PostId == IT_OFFICERS_BANKING_OFFICER_GR1_ID) {
        //     if (totalExperience < 3) {
        //         _notification.showMessage('error', 'Minimum 3 Years of Work Experience is required');
        //         valid = false;
        //     }
        // }

        // Condition For Work Experience feches from api GetCandidatePostData()

        if (totalExperience < this.state.postData.YearInExperience) {
            _notification.showMessage(
                'error', `Minimum ${this.state.postData.YearInExperience} years of work experience is required`
            );
            valid = false;
        }


        return valid;
    }

    isMandatoryQualificationFilled = (result) => {
        var valid = true;

        let mandatoryQual = this.state.parentQualification.filter((x) => x.IsMandetory);
        if (mandatoryQual.length == 0) {
            return true;
        }
        mandatoryQual.map(item => {
            if (result.filter((x) => x.Qualification_Id == item.Id).length == 0 && valid) {
                _notification.showMessage('error', 'Please provide mandatory education: ' + item.Qualification_Name);
                valid = false;
            }
        })

        return valid;
    }
    getQualificationID = (tempQualificationID) => {

        if (tempQualificationID < 1000) {
            return tempQualificationID;
        }

        let id = this.state.mappingIds && this.state.mappingIds.find(item => (item.split('_'))[1] == tempQualificationID);

        return id ? (id.split('_'))[0] : tempQualificationID;
    }

    updateCandidateQualificationData = async () => {
        try {
            let newThis = this;
            this.setState({
                loading: true
            }, async () => {
                try {

                    const studentID = newThis.state.candidateQualification.reduce((acc, curr) => {
                        return curr.Student_Id
                    }, [])
                    const result = newThis.state.candidateQualification.reduce((acc, curr) => {
                        let Specilisation = curr.Specilisation ? curr.Specilisation : "";
                        let Specilisation_Id = curr.Specilisation_Id ? curr.Specilisation_Id : 0;

                        acc.push({
                            Id: curr.Id ? curr.Id : 0,
                            Qualification_Id: curr.Id ? curr.Qualification_Id : curr.newRowID,
                            Specilisation: Specilisation,
                            University_Name: curr.University_Name ? curr.University_Name : "",
                            Passed_Year: curr.Passed_Year ? curr.Passed_Year : "",
                            Percentage_Grade: curr.Percentage_Grade ? curr.Percentage_Grade : "",
                            Class: curr.Class ? curr.Class : "",
                            Other_Information: curr.Other_Information ? curr.Other_Information : "",
                            Qualification: curr.Qualification ? curr.Qualification : "",
                            Specilisation_Id: Specilisation_Id,
                            University_Id: curr.University_Id ? curr.University_Id : 0,
                            other_specilisation: curr.other_specilisation ? curr.other_specilisation : "",
                        })
                        return acc
                    }, [])
                    let filteredResult = result.filter((item) => item.Other_Information != 'deleted')
                    filteredResult = filteredResult.filter((item) => item.University_Name != 'deleted')
                    filteredResult = filteredResult.filter((item) => item.other_specilisation != 'deleted')

                    if (!this.isValid(filteredResult)) {
                        this.setState({ loading: false });
                        return;
                    }

                    filteredResult && filteredResult.map(item => {
                        item.Qualification_Id = this.getQualificationID(item.Qualification_Id)
                    });

                    let workExpArray = [];
                    for (let i = 0; i < newThis.state.otherInformation.length; i++) {
                        if (i === 0) {
                            // Push the 0th index object into workExpArray
                            workExpArray.push(newThis.state.otherInformation[i]);
                        } else {
                            // Push objects with a value in Organisation into workExpArray
                            if (newThis.state.otherInformation[i].Organisation != null &&
                                newThis.state.otherInformation[i].Organisation != "") {
                                workExpArray.push(newThis.state.otherInformation[i]);
                            }
                        }
                    }

                    let body = { Student_Id: newThis.state.student_ID, listStudentQualification: filteredResult, listotherInformation: [...workExpArray] };

                    const response = await _StudentService.updateCandidateQualificationData(body);
                    if (response.data.IsSuccess) {
                        this.setState({
                            loading: false
                        }, () => {
                            _notification.showMessage('success', 'Candidate Qualification saved successfully.');
                            this.onTabOrderChange();
                            //this.props.history.push({pathname: routes.registrationComplete.basePath, state: { applicationID: response.data.ApplicationId }})
                        })
                    }
                    else {
                        this.setState({
                            loading: false
                        }, () => {
                            _notification.showMessage('error', response.data.Message);
                        })
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false })
                    console.log('Error: ', e);
                }
            });

        } catch (e) { 
            this.setState({ loading: false })
        }
    }



    onTextChange = (data, event) => {
        if (event.target.name == 'Organisation' && event.target.value.length > 50)
            return;

        if (event.target.name == 'Designation' && event.target.value.length > 35)
            return;

        if (data.hasOwnProperty('newRowID')) {
            var foundItem = this.state.otherInformation.find(item => item.newRowID == data.newRowID);
            if (foundItem) {
                foundItem[event.target.name] = event.target.value;
            }

        }
        else {
            var foundItem = this.state.otherInformation.find((item) => item.Id == data.Id);
            if (foundItem) {
                foundItem[event.target.name] = event.target.value;
            }
        }

        this.setState({
            otherInformation: [...this.state.otherInformation],
        });
    }

    onFromDateChange = (date, data, dateString) => {
        if (data.hasOwnProperty('newRowID')) {
            var foundItem = this.state.otherInformation.find(item => item.newRowID == data.newRowID);
            if (foundItem) {

                if (foundItem.To_Date) {
                    let from = moment(date);
                    let to = moment(foundItem.To_Date);

                    if (moment(to).isSameOrBefore(from)) {
                        _notification.showMessage("error", "From date should not be greater than To date.");
                        return;
                    }
                }

                foundItem.From_Date = date ? date.format("YYYY-MM-DDT00:00:00") : "";
            }

        }
        else {
            var foundItem = this.state.otherInformation.find((item) => item.Id == data.Id);
            if (foundItem) {

                if (foundItem.To_Date) {
                    let from = moment(date);
                    let to = moment(foundItem.To_Date);

                    if (moment(to).isSameOrBefore(from)) {
                        _notification.showMessage("error", "From date should not be greater than To date.");
                        return;
                    }
                }

                foundItem.From_Date = date ? date.format("YYYY-MM-DDT00:00:00") : "";
            }
        }

        this.setState({
            otherInformation: [...this.state.otherInformation],
        });
    };

    onToDateChange = (date, data, dateString) => {
        if (data.hasOwnProperty('newRowID')) {
            var foundItem = this.state.otherInformation.find(item => item.newRowID == data.newRowID);
            if (foundItem) {
                let from = moment(foundItem.From_Date);
                let to = date ? moment(date) : null;

                if (to && moment(to).isSameOrBefore(from)) {
                    _notification.showMessage("error", "From date should not be greater than To date.");
                    return;
                }

                foundItem.To_Date = date ? date.format("YYYY-MM-DDT00:00:00") : "";
            }
        } else {
            var foundItem = this.state.otherInformation.find(item => item.Id == data.Id);
            if (foundItem) {
                let from = moment(foundItem.From_Date);
                let to = date ? moment(date.format("YYYY-MM-DDT00:00:00")) : null;

                if (to && moment(to).isSameOrBefore(from)) {
                    _notification.showMessage("error", "From date should not be greater than To date.");
                    return;
                }

                foundItem.To_Date = date ? date.format("YYYY-MM-DDT00:00:00") : "";
            }
        }

        this.setState({
            otherInformation: [...this.state.otherInformation],
        });
    };

    onChangTypingShorthand = e => {
        //console.log(e.target.name, ' = ', !this.state.otherInformation[e.target.name]);

        if (this.state.otherInformation && this.state.otherInformation.length > 0) {

            var foundItem = this.state.otherInformation[0];

            foundItem[e.target.name] = !foundItem[e.target.name];
        }

        this.setState({
            otherInformation: [...this.state.otherInformation],
        });
    };

    onTabOrderChange = () => {
        this.props.onTabOrderChange(3);
    }

    onCancel = () => {
        this.props.onTabOrderChange(-1);
    }

    // Sprint 2.6.2 (Candidate Experience Modernization): a real "Previous" step, distinct from Cancel
    // (which exits to the dashboard) — returns to Personal Info (tabID 0), this screen's sole predecessor.
    onPrevious = () => {
        this.props.onTabOrderChange(0);
    }

    addNewRow = (data) => {
        let tempData = { ...data };

        let tempQualification = [...this.state.allQualification.filter((item) => item.ParentId == tempData.Id)];

        tempData._parentID = tempData.Id;
        tempData.Id = Math.floor(Math.random() * (9999999 - 10000 + 1) + 10000);

        let tempMappingIds = `${tempData._parentID}_${tempData.Id}`

        let _tempQualification = [];
        tempQualification && tempQualification.map(item => {
            _tempQualification.push({ ...item, ParentId: tempData.Id });
        })

        this.setState({
            ...this.state,
            parentQualification: [...this.state.parentQualification, tempData],
            allQualification: [...this.state.allQualification, ..._tempQualification, tempData],
            mappingIds: [...this.state.mappingIds, tempMappingIds]
        });
    }

    removeRow = (data) => {
        let remainingRows = this.state.parentQualification.filter(item => item.Id != data.Id);
        //let tmpRemainingCandidateQualifications = this.state.candidateQualification.filter(item => item.Qualification_Id != data.Id);
        let tmpRemainingCandidateQualifications = this.state.candidateQualification;

        let remainingCandidateQualifications = []
        tmpRemainingCandidateQualifications && tmpRemainingCandidateQualifications.map(item => {

            if (item.hasOwnProperty('newRowID') && item.newRowID != data.Id) {
                remainingCandidateQualifications.push(item);
            }

            if (item.hasOwnProperty('Id')) {
                if (item.Qualification_Id > 1000 && item.Qualification_Id != data.Id) {
                    remainingCandidateQualifications.push(item);
                }

                if (item.Qualification_Id < 1000 && item.Qualification_Id != data.Id) {
                    remainingCandidateQualifications.push(item);
                }
            }

        })

        this.setState({
            ...this.state,
            parentQualification: [...remainingRows],
            candidateQualification: [...remainingCandidateQualifications]
        });
    }

    addNewExperience = (data) => {
        let obj = {
            Is_Marathi_Typing_30: false,
            Is_English_Typing_40: false,
            Is_100_WPM: false,
            Is_120_WPM: false,
            Organisation: null,
            Designation: null,
            From_Date: null,
            To_Date: null,
            newRowID: Math.floor(Math.random() * (9999999 - 10000 + 1) + 10000)
        }

        this.setState({
            ...this.state,
            otherInformation: [...this.state.otherInformation, obj]
        });
    }

    removeExperience = (data) => {

        let remainingExp = this.state.otherInformation.filter(item => {
            if (item.hasOwnProperty('newRowID') && item.newRowID === data.newRowID) {
                return false;
            }
            if (item.hasOwnProperty('Id') && item.Id === data.Id) {
                return false;
            }
            return true;
        });

        this.setState({
            ...this.state,
            otherInformation: remainingExp
        });
    };

    //const StudentPersonalInfo = () => {
    render() {
        return (
            <>
                <NavigationTab onTabOrderChange={this.onTabOrderChange} currentStep={1} />
                {/* Sprint 2.6.2 (Candidate Experience Modernization): `loading` was tracked around every
                    API call in this file but never rendered — candidates got zero visual feedback while
                    education/experience rows or the final save were in flight. */}
                {this.state.loading && <LoadingSpinner />}

                {/* Stage 3.9 (Task 1): mt-4/mb-4 -> mt-3/mb-3 — density trim. */}
                <div className="candidate-qualif ent-container gl-bxbr  analysisWrap p-4 mt-3">
                    <h4 className="ch-heading4 mb-3"><Text k="qualificationInfo.pageHeading" /></h4>
                    <Card header={<h5 className="ch-heading5"><Text k="qualificationInfo.educationalDetailsHeading" /></h5>} className="candidate-qualif-details">
                        <div className='container-fluid pr-0 pl-0 no-border hideon-mobile'>
                            <QualificationTableHeader candidatePersonalInfo={this.state.candidatePersonalInfo} />
                        </div>
                        {this.state.parentQualification.filter((item) => item.ParentId === null).sort((a, b) => a._parentID - b._parentID).map((item, index) => (
                            <div className='container-fluid pr-0 pl-0'>
                                <QualificationRow row={item} data={this.state.allQualification} candidateData={this.state.candidateQualification}
                                    allUniversities={this.state.allUniversities} onCandidateQualification={this.onCandidateQualification} key={item.Id} addNewRow={this.addNewRow} removeRow={this.removeRow}
                                    candidatePersonalInfo={this.state.candidatePersonalInfo}
                                    // Phase C.7.4D-R6.3 (§4): already-fetched post-specific requirement data
                                    // (same PostConfiguration rows the client-side isValid() check already
                                    // reads) — passed through purely so the row can show a "Minimum
                                    // percentage.../Accepted grades..." hint. No new API call, no new rule.
                                    percentageData={this.state.percentageData}
                                    gradeData={this.state.gradeData}
                                />
                            </div>
                        ))}
                    </Card>
                    {/* Phase C.7.4D-R6.4: Typing/Shorthand previously occupied a full-width card with 2
                        widely col-sm-5-spaced rows for only 2 checkboxes each — a large amount of empty
                        vertical space for a small amount of content. Same InputCheck components, same
                        `onChangTypingShorthand` handler, same `checked` derivation — only the wrapping
                        layout changes to a compact, wrapping tile group (`qualif-tile-group`/`qualif-tile`,
                        styled in themes.scss), so selection state and persistence are unaffected. */}
                    <Card header={<h5 className="ch-heading5"><Text k="qualificationInfo.typingDetailsHeading" /></h5>}>
                        <div className="container-fluid  pr-0 pl-0">
                            <div className="qualif-tile-group">
                                <InputCheck
                                    id="Is_Marathi_Typing_30"
                                    type="checkbox"
                                    label={<div className='displayInGrid'>
                                        <Text k="qualificationInfo.marathiTyping30Label" />
                                    </div>}
                                    wrapclassName="qualif-tile"
                                    name="Is_Marathi_Typing_30"
                                    value="false"
                                    onChange={this.onChangTypingShorthand}
                                    checked={(this.state.otherInformation && this.state.otherInformation.length > 0) ? this.state.otherInformation[0].Is_Marathi_Typing_30 ? this.state.otherInformation[0].Is_Marathi_Typing_30 : false : false}
                                />
                                <InputCheck
                                    id="Is_English_Typing_40"
                                    type="checkbox"
                                    label={<div className='displayInGrid'>
                                        <Text k="qualificationInfo.englishTyping40Label" />
                                    </div>}
                                    wrapclassName="qualif-tile"
                                    name="Is_English_Typing_40"
                                    value="false"
                                    onChange={this.onChangTypingShorthand}
                                    checked={(this.state.otherInformation && this.state.otherInformation.length > 0) ? this.state.otherInformation[0].Is_English_Typing_40 ? this.state.otherInformation[0].Is_English_Typing_40 : false : false}
                                />
                            </div>
                        </div>
                    </Card>
                    <Card header={<h5 className="ch-heading5"><Text k="qualificationInfo.shortHandDetailsHeading" /></h5>}>
                        <div className="container-fluid  pr-0 pl-0">
                            <div className="qualif-tile-group">
                                <InputCheck
                                    id="Is_100_WPM"
                                    type="checkbox"
                                    label={<div className='displayInGrid'>
                                        <Text k="qualificationInfo.wpm100Label" />
                                    </div>}
                                    wrapclassName="qualif-tile"
                                    name="Is_100_WPM"
                                    value="false"
                                    onChange={this.onChangTypingShorthand}
                                    checked={(this.state.otherInformation && this.state.otherInformation.length > 0) ? this.state.otherInformation[0].Is_100_WPM ? this.state.otherInformation[0].Is_100_WPM : false : false}
                                />
                                <InputCheck
                                    id="Is_120_WPM"
                                    type="checkbox"
                                    label={<div className='displayInGrid'>
                                        <Text k="qualificationInfo.wpm120Label" />
                                    </div>}
                                    wrapclassName="qualif-tile"
                                    name="Is_120_WPM"
                                    value="false"
                                    onChange={this.onChangTypingShorthand}
                                    checked={(this.state.otherInformation && this.state.otherInformation.length > 0) ? this.state.otherInformation[0].Is_120_WPM ? this.state.otherInformation[0].Is_120_WPM : false : false}
                                />
                            </div>
                        </div>
                    </Card>
                    <Card header={<h5 className="ch-heading5"><Text k="qualificationInfo.workExperienceHeading" /></h5>} className="qualif-experience">
                        <div className="container-fluid  pr-0 pl-0" style={{ overflow: 'hidden' }}>


                            {/* Phase C.7.4D-R6.4: each entry now gets a clear "Experience N" heading, and
                                the add/remove control moves next to it as visible icon+text (reusing the
                                same `.qualif-row-action` treatment as the Educational Details rows), in
                                place of the previous isolated tiny plus/remove icon at the end of the date
                                columns. Same `addNewExperience`/`removeExperience` handlers, same
                                index===0-adds/index>0-removes logic — no functional change. */}
                            {this.state.otherInformation && this.state.otherInformation.map((item, index) =>
                                <>
                                    <div className="qualif-row-header">
                                        <div className="qualif-row-header-title">
                                            <Text k="qualificationInfo.experienceLabel" />{" "}{index + 1}
                                        </div>
                                        {index == 0 &&
                                            <div
                                                className="addNew-row qualif-row-action qualif-row-action--add"
                                                data-name="Add Experience"
                                                onClick={() => this.addNewExperience(item)}
                                                role="button"
                                                tabIndex={0}
                                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { this.addNewExperience(item); } }}
                                            >
                                                <img src={add_new} width={16} height={16} className="qualif-row-action-icon" alt="" />
                                                <span>{tr('qualificationInfo.addExperienceTitle')}</span>
                                            </div>
                                        }
                                        {index > 0 &&
                                            <div
                                                className="removeadded-row qualif-row-action qualif-row-action--remove"
                                                data-name="Remove Experience"
                                                onClick={() => this.removeExperience(item)}
                                                role="button"
                                                tabIndex={0}
                                                onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { this.removeExperience(item); } }}
                                            >
                                                <img src={remove} width={16} height={16} className="qualif-row-action-icon" alt="" />
                                                <span>{tr('qualificationInfo.removeExperienceTitle')}</span>
                                            </div>
                                        }
                                    </div>
                                    <div className={index > 0 ? "row pt-3 bordert" : "row"}>
                                        <div className="col-sm-8">
                                            <div>
                                                <MyInput
                                                    type="text"
                                                    value={item ? item.Organisation ? item.Organisation : "" : ""}
                                                    name="Organisation"
                                                    onChange={(e) => this.onTextChange(item, e)}
                                                    heading={<div className='displayInGrid'><Text k="qualificationInfo.organizationNameLabel" /></div>}
                                                    className="w-100"
                                                    wrapClass="wrap"
                                                    isRequired={this.state.postData.YearInExperience > 0}
                                                    errorState={this.state.mobileError}
                                                    errorMessage={this.state.mobileError}
                                                />
                                            </div>

                                            <div>
                                                <MyInput
                                                    type="text"
                                                    value={item ? item.Designation ? item.Designation : "" : ""}
                                                    name="Designation"
                                                    onChange={(e) => this.onTextChange(item, e)}
                                                    heading={<div className='displayInGrid'><Text k="qualificationInfo.designationLabel" /></div>}
                                                    className="w-100"
                                                    wrapClass="wrap"
                                                    // isRequired={(this.state.candidatePersonalInfo.Applied_PostId === JUNIOR_MANAGEMENT_ID)
                                                    //     ? true : false}
                                                    isRequired={this.state.postData.YearInExperience > 0}
                                                    errorState={this.state.mobileError}
                                                    errorMessage={this.state.mobileError}
                                                />
                                            </div>

                                        </div>
                                        <div className="col-sm-4 d-flex mobile-col">
                                            <div className="qualif-datePicker">
                                                <div>
                                                    <div className="wrap form-group">
                                                        <label>
                                                            <div className='displayInGrid'>
                                                                <Text k="qualificationInfo.fromDateLabel" />
                                                            </div>
                                                            {/* {(this.state.postData.YearInExperience && this.state.postData.YearInExperience > 0) &&
                                                                <span className='color-red'>*</span>
                                                            } */}

                                                            {this.state.postData.YearInExperience > 0 && (
                                                                <span className='color-red'>*</span>
                                                            )}

                                                        </label>

                                                        <DatePicker onChange={(date) => this.onFromDateChange(date, item)} format="DD-MMM-YYYY" value={item ? item.From_Date ?
                                                            moment(item.From_Date == '0001-01-01T00:00:00' ? moment().format('YYYY-MM-DD') : item.From_Date, 'YYYY-MM-DD') : "" : ""}
                                                            disabledDate={d => !d || d.isAfter(moment()) || d.isSameOrBefore("1900-01-01")}
                                                            className={
                                                                ((this.state.dobError) ? "has-error" : "")
                                                            } />
                                                    </div>

                                                </div>
                                                <div>
                                                    <div className="wrap form-group">
                                                        <label>
                                                            <div className='displayInGrid'>
                                                                <Text k="qualificationInfo.toDateLabel" />
                                                            </div>
                                                            {/* {(this.state.postData.YearInExperience && this.state.postData.YearInExperience > 0) &&
                                                                <span className='color-red'>*</span>
                                                            } */}

                                                            {this.state.postData.YearInExperience > 0 && (
                                                                <span className='color-red'>*</span>
                                                            )}

                                                        </label>
                                                        <DatePicker onChange={(date) => this.onToDateChange(date, item)} format="DD-MMM-YYYY"
                                                            value={
                                                                item
                                                                    ? item.To_Date
                                                                        ? moment(item.To_Date == '0001-01-01T00:00:00' ? moment().format('YYYY-MM-DD') : item.To_Date, 'YYYY-MM-DD')
                                                                        : null
                                                                    : null
                                                            }
                                                            disabledDate={d => !d || d.isAfter(moment()) || d.isSameOrBefore("1900-01-01")}
                                                            className={
                                                                ((this.state.dobError) ? "has-error" : "")
                                                            } />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                            {/* Phase C.7.4D-R6.4B (annotated correction 4): same wording/data as before
                                (`noteLabel` + `Candidate_Experience_Note`) — refined into a clearer
                                advisory-callout presentation (icon, left accent, more deliberate spacing)
                                scoped to this page only via `qualif-note`, since the base `.ch-note`
                                class is shared with ForgotPassword and Challan Details. */}
                            <div className='ch-note qualif-note mt-4  mb-3'>
                                <div className="candidate-container p-4">
                                    <div className='h5 font-weight-bold qualif-note-title'>
                                        <Icon type="info-circle" theme="filled" />
                                        <Text k="qualificationInfo.noteLabel" />
                                    </div>
                                    <div className="qualif-note-body" dangerouslySetInnerHTML={{ __html: this.state.config.Candidate_Experience_Note }}></div>
                                </div>
                            </div>

                        </div>
                    </Card>
                    <div className="row mt-4">
                        <div className="col-12">
                            <div className=" form-action d-flex justify-content-end ">
                                {/* Phase C.7.4D-R6.4: 3-tier action hierarchy — Save (primary, unchanged),
                                    Previous (secondary/bordered, unchanged), Cancel now tertiary/
                                    destructive-neutral (`button-tertiary`, new in themes.scss) instead of
                                    sharing the same bordered treatment as Previous. Same `onCancel`
                                    handler — no behaviour change. */}
                                <ButtonComponent
                                    id="btnCancel"
                                    type="button"
                                    value={<div className='displayInGrid'><Text k="qualificationInfo.cancelButton" /></div>}
                                    className="button-global button-tertiary mr-4 autoHeight"
                                    onClick={this.onCancel} />

                                <ButtonComponent
                                    id="btnPrevious"
                                    type="button"
                                    value={<div className='displayInGrid'><Text k="qualificationInfo.previousButton" /></div>}
                                    className="button-global button-border mr-4 autoHeight"
                                    onClick={this.onPrevious} />

                                <ButtonComponent
                                    id="btnSubmit"
                                    type="button"
                                    value={<div className='displayInGrid'><Text k="qualificationInfo.saveButton" /></div>}
                                    className="button-global button-primary autoHeight"
                                    onClick={this.updateCandidateQualificationData} />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    };
}

export default CandidateQualificationInfo_new;